<template>
  <div ref="dropdown" class="language-dropdown">
    <button
      class="language-dropdown__btn flex ttc btn btn--text items-center bg-transparent"
      style="margin-left: auto;"
      ref="dropdownButton"
      @click="handleLanguageDropdownClick"
      @keydown.esc="closeLanguageDropdown"
    >
      <span class="lang_icon"><svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.783 0.599609C5.26297 0.599609 0.792969 5.07961 0.792969 10.5996C0.792969 16.1196 5.26297 20.5996 10.783 20.5996C16.313 20.5996 20.793 16.1196 20.793 10.5996C20.793 5.07961 16.313 0.599609 10.783 0.599609ZM17.713 6.59961H14.763C14.443 5.34961 13.983 4.14961 13.383 3.03961C15.223 3.66961 16.753 4.94961 17.713 6.59961ZM10.793 2.63961C11.623 3.83961 12.273 5.16961 12.703 6.59961H8.88297C9.31297 5.16961 9.96297 3.83961 10.793 2.63961ZM3.05297 12.5996C2.89297 11.9596 2.79297 11.2896 2.79297 10.5996C2.79297 9.90961 2.89297 9.23961 3.05297 8.59961H6.43297C6.35297 9.25961 6.29297 9.91961 6.29297 10.5996C6.29297 11.2796 6.35297 11.9396 6.43297 12.5996H3.05297ZM3.87297 14.5996H6.82297C7.14297 15.8496 7.60297 17.0496 8.20297 18.1596C6.36297 17.5296 4.83297 16.2596 3.87297 14.5996ZM6.82297 6.59961H3.87297C4.83297 4.93961 6.36297 3.66961 8.20297 3.03961C7.60297 4.14961 7.14297 5.34961 6.82297 6.59961ZM10.793 18.5596C9.96297 17.3596 9.31297 16.0296 8.88297 14.5996H12.703C12.273 16.0296 11.623 17.3596 10.793 18.5596ZM13.133 12.5996H8.45297C8.36297 11.9396 8.29297 11.2796 8.29297 10.5996C8.29297 9.91961 8.36297 9.24961 8.45297 8.59961H13.133C13.223 9.24961 13.293 9.91961 13.293 10.5996C13.293 11.2796 13.223 11.9396 13.133 12.5996ZM13.383 18.1596C13.983 17.0496 14.443 15.8496 14.763 14.5996H17.713C16.753 16.2496 15.223 17.5296 13.383 18.1596ZM15.153 12.5996C15.233 11.9396 15.293 11.2796 15.293 10.5996C15.293 9.91961 15.233 9.25961 15.153 8.59961H18.533C18.693 9.23961 18.793 9.90961 18.793 10.5996C18.793 11.2896 18.693 11.9596 18.533 12.5996H15.153Z" fill="white"/>
</svg></span>
      <span class="language-dropdown__text" >{{selectedLanguage}}</span>
      <div class="icon language-dropdown__text">
        <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.12428 5.49839C4.72563 6.05939 3.89263 6.05939 3.49398 5.49839L1.11861 2.15567C0.64811 1.49356 1.1215 0.576418 1.93376 0.576418L6.6845 0.576418C7.49676 0.576418 7.97015 1.49356 7.49965 2.15567L5.12428 5.49839Z" fill="white"/>
        </svg>
      </div>
    </button>

    <div @blur="onBlur" ref="dropdownList" tabindex="0">
      <ul
        :class="{'w-100': !languageChosen}"
        class="language-dropdown__list"
        v-if="languageDropdownVisible"
      >
        <li v-for="language in languages" :key="language.language">
          <a
            @click="handleClose(language.language)"
            :id="language.title"
            class="link"
            :class="{'language-selected': (getLanguage() === language.language)}"
            href="#"
          >{{language.language}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getLanguage, getPathNameFromRouteName, findElementInChildren, setCookie, getCookie } from '@/utils/common';
export default {
  data() {
    return {
      languageDropdownVisible: false,
      languages: [
        { flag: 'us', language: 'en-us', title: 'English' },
        { flag: 'fr', language: 'fr', title: 'French' },
        { flag: 'it', language: 'it', title: 'Italian' },
        { flag: 'ja', language: 'ja', title: 'Japanese' },
        { flag: 'pt', language: 'pt', title: 'Portuguese' },
        { flag: 'es', language: 'es', title: 'Spanish' },
        { flag: 'ms', language: 'ms', title: 'Malay' }
      ],
      languageChosen: getCookie('lng_chosen')
    };
  },
  computed: {
    selectedLanguage() {
      let selectedLanguageObject = this.languages.find(language => {
        return getLanguage() === language.language;
      });
      return selectedLanguageObject.language;
    }
  },
  methods: {
    ...mapActions(['changeLanguage']),
    getLanguage: getLanguage,
    handleClose(language) {
      let originalLocation = window.location.href;
      /* eslint-disable no-useless-escape */
      let regex = new RegExp(`\/${getLanguage()}`, 'g');
      this.changeLanguage(language).then(() => {
        setCookie('lng_chosen', true);
        let redirectPathName = `${getPathNameFromRouteName(this.$route.name, this.$router)}${window.location.search}`;
        const queryHash = originalLocation.match(new RegExp('query' + '=([^&]*)'));
        if (queryHash) {
          redirectPathName = `${redirectPathName}#query=${decodeURIComponent(queryHash[1])}`;
        }
        if (redirectPathName) {
          window.location.href = `/${language}/${redirectPathName.replace(/ /g, '-')}`;
        } else {
          window.location.href = originalLocation.replace(regex, `/${language}`);
        }
      });
    },
    toggleOpenState() {
      this.languageDropdownVisible = !this.languageDropdownVisible;
    },
    handleLanguageDropdownClick(e) {
      this.toggleOpenState();
      if (this.languageDropdownVisible) {
        this.$refs.dropdownList.focus();
      }
    },
    closeLanguageDropdown() {
      this.languageDropdownVisible = false;
    },
    onBlur(e) {
      const children = Array.from(this.$refs.dropdownList.children);
      const target = e.relatedTarget;
      const found = children.find(child => findElementInChildren(child, target));
      if (!found && target !== this.$refs.dropdownButton) {
        this.languageDropdownVisible = false;
        this.$refs.dropdownButton.blur();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.language-dropdown {
  position: relative;
  z-index: 2;
}
.lang_icon {
  width: 20px;
  display: inline-block;
  margin: 0 6px 0 0;
}
.language-dropdown__list {
  z-index: 2;
  position: absolute;
  text-align: left;
  background-color: #F6F6FF;
  text-decoration: none;
  border: 1px solid #6b90da;
  overflow: hidden;
  padding: 5px 0;
  margin: 0.3rem 0 0 0;
  border-radius: 5px;
  animation: bounce 0.6s ease-out;
  font-size: 14px;
  text-transform: uppercase;
  right: 20px;
  list-style: none;

  .text {
    margin: 0;
    padding: 0.2rem;
    font-weight: 600;
    color: #000;
    font-size: 0.9rem;
  }
  .link {
    padding: 4px 15px;
    color: #3638DC;
    font-weight: 400;
    font-size: 14px;
  }
  .link:hover {
    background-color: #3638DC;
    color: #fff;
  }
  .text,
  .link {
    display: block;
  }
}
.language-dropdown__text {
  &.icon {
    display: inline-block;
    margin: -4px 0 0 8px;
  }
}
.language-selected {
  font-weight: 600 !important;
}
.language-dropdown__btn {
  padding: 0;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 700;
  color: #fff;
  margin-bottom: .75rem;
}
.language-dropdown__btn:focus {
  outline: none;
  border: none;
}
.language-dropdown__btn:hover {
  opacity: 0.8;
  cursor: pointer;
}
.language-dropdown__separator {
  border-left: 1px solid rgb(187, 187, 187);
  margin-left: 6px;
}
@media (min-width: 480px) {
  .language-dropdown__btn {
    padding: 0 20px;
    margin: 0;
  }
}
</style>
